// wishlist - begin
jQuery(document).ready(function ($) {

	$('body').on('click','.product-add-to-wishlist-button',function(e){
		e.preventDefault();

		if($(this).data('wli-added') == true) {

			//if item added to the wishlist...
			window.location.href = '/account/wish_list';

		} else {

			// mimic Add to Card button overlay
			var form = $(this).closest('.add-to-cart-form');
			var postWLData = {sku: $(this).data('wli')}
			var button = $('.product-add-to-cart-button', form);
			button.addClass('is-ajax-hiding');

			// change text on the button
			$(this).text('Saved to Wish List');
			$(this).attr('data-wli-added', 'true');

			// ajax call to save to wish list
			addToWishList(postWLData, button);

		}
	});

	$('body').on('click','.product-redirect-button',function(e){
		e.preventDefault();

		window.location.href = $(this).data('wli');
	});
});


function addToWishList(postData, button) {
	$.ajax({
		beforeSend: function() {
			button.addClass('is-ajax-hiding');
		},
		type: "get",
		url: "/products/save_to_wishlist",
		data : postData,
		success: function(data) {
			if (data.error == true) {
				var message = 'Item could not be added to&nbsp;Wish List. Please try again&nbsp;later.';
				if(data.error_message !== undefined && data.error_message !== '') {
					message = data.error_message;
				}
				button.siblings('.wishlist-ajax-message').html('<i class="icon-alert" aria-hidden="true"></i><br>' + message).removeClass('is-ajax-hiding').addClass('error');
			} else {
				button.siblings('.wishlist-ajax-message').html('<i class="icon-checkmark" aria-hidden="true"></i><br>Item&nbsp;added to&nbsp;Wish List!').removeClass('is-ajax-hiding error');
			}
		},
		error: function(data) {
			button.siblings('.wishlist-ajax-message').html('Item could not be added to Wish List. Please try again later.').removeClass('is-ajax-hiding').addClass('error');
		}

	});
	setTimeout(function() {
		button.siblings('.wishlist-ajax-message').addClass('is-ajax-hiding').removeClass('error');
		button.siblings('.wishlist-ajax-message').removeClass('.wishlist-add-message');
		button.removeClass('is-ajax-hiding');

	}, 6000);
}
// wishlist - end
